import { useMemo } from "react"
import { useDispatch, useSelector } from "react-redux"
import { convertFileDataForUrl } from "../../app/documentUploadUtils"
import { fetchDocumentData } from "../../redux/slice/supportingDocumentsSlice"
import { NavigationLinkButton } from "../RegularComponents"

export function DocumentViewerFileNameLink(props) { 
    return (
        <NavigationLinkButton 
            id={props.id}
            key={props.key}
            text={props.file.filename}
            onClick={props.onClick}
        />
    )
}

export function DownloadFileNameLink(props) { 
    const {file} = props

    const dispatch = useDispatch()
    // const fileDataUrl = convertFileDataForUrl(file.data, file.documentContentType);

    const cacheData = useSelector((state) => state.components.supportingDocuments.cacheData)
    const fileDataUrl = useMemo(() => {
        if(file.data) {
            return convertFileDataForUrl(file.data, file.documentContentType);
        }
        // console.log("looking for cached file for:" + file.guid)

        const cachedFile = cacheData.find(cachedFileData => cachedFileData.key === file.guid)
        if(!cachedFile) {
            dispatch(fetchDocumentData(file.guid))
            return null;
        }

        return convertFileDataForUrl(cachedFile.data.data, file.documentContentType)
    }, [dispatch, cacheData, file])

    // if(!fileDataUrl) {
    //     return <span>loading</span>
    // }
    return (
        <div className="documentLinkAnchor">
            <a
                id={props.id}
                key={props.componentKey ?? "downloadable-filename-anchor"}
                className={ (props.className ? props.className : "") + " paddingNormal"}
                download={file.filename} 
                href={fileDataUrl}>
                    <u>{file.filename}</u>
            </a>
        </div>
    )
}